<template>
  <el-dialog
    title="Thanh toán chuyển khoản"
    :visible.sync="dialogPaymentVisible"
    :close-on-click-modal="false"
    width="835px"
    @close="onClose"
  >
    <div class="das-form-container">
      <InfoList :columns="2">
        <InfoListLabel>
          <span>Ngày</span>
        </InfoListLabel>
        <InfoListValue>
          <span>{{ $displayDate(new Date()) }}</span>
        </InfoListValue>

        <InfoListLabel>
          <span>Nguồn</span>
        </InfoListLabel>
        <InfoListValue>{{ data?.sourceNm }}</InfoListValue>

        <InfoListLabel>
          <span>Công ty/Đại lý</span>
        </InfoListLabel>
        <InfoListValue>{{ data?.agentNm }}</InfoListValue>

        <InfoListLabel>
          <span>Kế toán</span>
        </InfoListLabel>
        <InfoListValue>{{ user?.full_name }}</InfoListValue>

        <InfoListLabel>
          <span class="label-required">Số tiền</span>
        </InfoListLabel>
        <InfoListValue
          ><div style="display: flex; gap: 10px">
            <VxCurrencyInput v-model="formData.money" style="flex: 2" />
            <el-select
              v-model="formData.currency_id"
              style="flex: 1"
              placeholder=""
            >
              <el-option
                v-for="item1 in currencyOptions"
                :key="item1.id"
                :label="item1.code"
                :value="item1.id"
              >
              </el-option>
            </el-select></div
        ></InfoListValue>

        <InfoListLabel>
          <span>Tài khoản nhận</span>
        </InfoListLabel>
        <InfoListValue>
          <select-with-search-table
            style="width: 100%"
            :dropdown-width="400"
            :rows="bankAccOptions"
            :columns="selectSearchCol"
            :search-fields="['code']"
            :value="formData.bank_account_id"
            :selected-index-field-value="formData.bank_account_id"
            index-field="id"
            @selectionChanged="onSelectRowOption"
          >
            <template v-slot:value="{ selectedValue: selectedData }">
              {{ selectedData?.name }}
            </template>
          </select-with-search-table>
        </InfoListValue>

        <InfoListLabel>
          <span class="">Tổng số dư hóa đơn</span>
        </InfoListLabel>
        <InfoListValue>
          <span
            style="
              color: #357456;
              font-weight: 700;
              cursor: pointer;
              user-select: none;
            "
            @click="formData.money = totalInvoiceMoneyData"
            >{{ formatVND(totalInvoiceMoney) }} VND</span
          ></InfoListValue
        >

        <InfoListLabel>Ghi chú</InfoListLabel>
        <InfoListValue>
          <textarea v-model="formData.note" style="width: 100%" :rows="3" />
        </InfoListValue>
      </InfoList>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogPaymentVisible = false"
        >
          Đóng
        </button>
        <button class="btn primary small" @click="submitPaymentForm">
          Thanh toán
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import VxCurrencyInput from '@/components/ui/VxCurrencyInput'

import { getListBankAccountApi } from '@/api/configuration/accounting/bankAccount.js'
import { getUserDetailApi } from '@/api/profile/profile'
import { paymentDebAccount } from '@/api/report_service/datntReport'
import { formatVND } from '@/utils/commonUtils'

export default {
  components: { VxCurrencyInput },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    transactionCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      formData: {
        money: 0,
        note: null,
        invoices: [], // { money: 0, invoice_code: null }
        bank_account_id: null,
        currency_id: 5,
        transaction_code: this.transactionCode
      },
      defaultFormData: {
        money: 0,
        note: null,
        invoices: [], // { money: 0, invoice_code: null }
        bank_account_id: null,
        currency_id: 5,
        transaction_code: ''
      },
      user: null,
      totalInvoiceMoney: 0,
      totalInvoiceMoneyData: 0,

      // data for select
      currencyOptions: [
        {
          id: 5,
          code: 'VND'
        }
      ],
      bankAccOptions: [],
      selectSearchCol: [
        {
          headerName: 'Mã tài khoản',
          field: 'code'
        },
        {
          headerName: 'Tên ngân hàng',
          field: 'name'
        },
        {
          headerName: 'Số tài khoản',
          field: 'acc_num'
        }
      ]
    }
  },
  computed: {
    dialogPaymentVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    async value(nv, ov) {
      if (nv) {
        this.totalInvoiceMoneyData = this.data.invoices.reduce(
          (acc, cur) => acc + cur?.debt,
          0
        )
        this.totalInvoiceMoney = this.totalInvoiceMoneyData
        await this.getBankAccounts()
        await this.getUserDetail()
      }
    },
    'formData.money'(nv, ov) {
      this.totalInvoiceMoney = this.totalInvoiceMoneyData - nv
    },
    transactionCode(nv, ov) {
      this.formData.transaction_code = nv
    }
  },

  methods: {
    formatVND,
    onSelectRowOption(val) {
      this.formData.bank_account_id = val.id
    },
    onClose() {
      this.formData = Object.assign({}, this.defaultFormData)
    },

    // handle api call
    async submitPaymentForm() {
      // valid
      if (this.formData.money > this.totalInvoiceMoneyData) {
        this.$message({
          type: 'error',
          message: 'Không thể thanh toán số tiền vượt quá tổng số dư hóa đơn'
        })
        return false
      }
      if (this.formData.money <= 0) {
        this.$message({
          type: 'error',
          message: 'Số tiền thanh toán phải lớn hơn 0'
        })
        return false
      }
      this.formData.invoices = this.data?.invoices.map(item => ({
        money: item.debt,
        invoice_code: item.invoice_num,
        expire_date: item.num_of_day_due,
        ticket_sales_payment_id: item?.ticket_sales_payment_id,
        room_transaction_payment_id: item?.room_transaction_payment_id
      }))
      try {
        const res = await paymentDebAccount(this.formData)
        this.$message({
          type: 'success',
          message: this.$t(`successMsg.${res?.message}`)
        })
        this.dialogPaymentVisible = false
        this.$emit('refresh')
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      }
    },
    async getUserDetail() {
      const data = await getUserDetailApi()
      this.user = data.data.user
    },
    async getBankAccounts() {
      const data = await getListBankAccountApi({ active: true })
      this.bankAccOptions = data.data
      this.formData.bank_account_id = this.bankAccOptions[0]?.id
    }
  }
}
</script>
